import { Tooltip, TooltipProps } from '@mui/material'
import { useTranslate } from 'ra-core'
import React from 'react'

const KToolTip: React.FC<TooltipProps> = ({
  children,
  title,
  placement = 'bottom-start',
  ...rest
}) => {
  const translate = useTranslate()
  return (
    <Tooltip {...rest} title={translate(String(title))} placement={placement}>
      <div>{children}</div>
    </Tooltip>
  )
}

export default KToolTip
